import React, { Component } from 'react';
import Entry from '../_core/models/Entry';
import Data from '../_core/models/Data';
import Link from '../_core/components/Link';
import Content from '../_core/components/Content';
import Gallery from '../_core/components/Gallery';
import Image from '../_core/components/Image';
import Icon from '../_core/components/Icon';
import Html from '../_core/components/Html';
import SiteModifier from '../_core/components/SiteModifier';
import Container from '../components/Container';
import CarouselGallery from '../components/CarouselGallery';

const IS_TOUCH = 'ontouchstart' in window || navigator.msMaxTouchPoints;

class Default extends Component {

	slider = null;
  	cur = 0;

	constructor(props) {
		super(props);
		this.state = {slide:1}
	}

	componentDidMount() {



	}

	componentWillUnmount() {

	}

	initSlider = (slider) => {
  		this.slider = slider;
  		//this.goTo(0);
	}


	/*

		RENDER

	*/

	render() {

		
		let {entry} = this.props;

		return (
			<div className="Template Template--default">
			<SiteModifier modifier="cursor" demodifier={'cursorLeft,cursorRight,click'} auto />

			<Data require={['HOME']}>
			{({HOME,entries})=>{
				{

					let projects = HOME.projects.map(id => entries.find(e => (e.id == id)));
					
					
					let cur = projects.find(i=>{
						return (i.uri == entry.uri)
					});


					let resetSlide = (cur) ? (projects.indexOf(cur) + 1) : 0;

					if(resetSlide > (projects.length - 1)){
						resetSlide = 0;
					}

					window.SLIDE_IX = resetSlide;

					return null

				}
			}}
			</Data>

			<div className="Template-gallery">
				
				{(()=>{

					if(IS_TOUCH || (window.innerWidth < 700)){
						return (
							<React.Fragment>
								<CarouselGallery onChange={(ix)=>this.setState({slide:ix+1})} api={this.initSlider}>
									{
										entry.data.body1.map(
											(i,ix) => (
												<div className={`Gallery-slide ${(i.items.length > 1) ? 'Gallery-slide--multi' : ''}`} key={'slide_'+ix}>
							                      	{i.items.map(
							                      		(img,iix) => <div className={`Gallery-image`} data-custom={img.use_custom_layout ? "Custom" : null} data-custom-y={img.use_custom_layout ? img.y_row : 'auto'} data-custom-x={img.use_custom_layout ? img.x_col : 'auto'} data-custom-w={img.use_custom_layout ? (((parseInt(img.x_col) + parseInt(img.w_col)) > 12) ? (12 - img.x_col) : img.w_col) : 'auto'} data-custom-h={img.use_custom_layout ? (((parseInt(img.y_row) + parseInt(img.h_row)) > 12) ? (12 - img.y_row) : img.h_row) : 'auto'} data-style={img.style} data-align={img.align} data-fit={img.fit} key={'img_'+iix+img.image.url}><Link to={`#/enlarge/${encodeURIComponent(img.image.url)}/`}><Image src={img.image.url}  fluid={true} lazy={true} /></Link></div>
							                      	)}
							                     </div>
											)
										)
									}
								</CarouselGallery>
							</React.Fragment>
						)
					}else{

						return (
							<Container>
								<SiteModifier hover hovermodifier={'cursor'}>
								<div className="Template-gallery-cursor-target">
								<Gallery 
								modifier="slides"
								prev={

									<SiteModifier hover hovermodifier={'cursorLeft'}><div className="Gallery-cursor-target" /></SiteModifier>

								}

								next={

									<SiteModifier hover hovermodifier={'cursorRight'}><div className="Gallery-cursor-target" /></SiteModifier>

								}

								 slidesToLoad={2} items={entry.data.body1} onChange={(ix) => this.setState({slide:(ix + 1)})} getItem={(i,ix,active)=>{
				                  return (
				                  
				                      <div className="Gallery-slide" key={'slide_'+ix}>
				                      	{i.items.map(
				                      		(img,iix) => <div className={`Gallery-image`} data-custom={img.use_custom_layout ? "Custom" : null} data-custom-y={img.use_custom_layout ? img.y_row : 'auto'} data-custom-x={img.use_custom_layout ? img.x_col : 'auto'} data-custom-w={img.use_custom_layout ? (((parseInt(img.x_col) + parseInt(img.w_col)) > 12) ? (12 - img.x_col) : img.w_col) : 'auto'} data-custom-h={img.use_custom_layout ? (((parseInt(img.y_row) + parseInt(img.h_row)) > 12) ? (12 - img.y_row) : img.h_row) : 'auto'} data-style={img.style} data-align={img.align} data-fit={img.fit} key={'img_'+iix+img.image.url}><Image src={img.image.url}  fluid={true} lazy={true} /></div>
				                      	)}
				                      </div>
				                    
				                  )
				                }} />
				                </div>
				                </SiteModifier>
							 </Container>
						)

					}

				})()}
				
               
			</div>



			<div className="Template-info" >
				<div className="Template-info-wash" style={{background:entry.data.information_colour}} />


				<div className="Template-info-content">
					<div className="Template-info-close"><Link to={entry.uri}><Icon glyph type={'cross'} /></Link></div>
					<div className="Template-info-scroll">
					<div className="Template-info-text">
				<Content>
					<h2>{entry.title}</h2>
					<Html html={entry.body} />

				</Content>
				</div>
				</div>
				</div>
			</div>
			<div className="Template-foot">
				<Container>
					<div data-grid-of="3" data-mobile-grid-of="4">
						<div><Link to="/">Back</Link></div>
						<div data-mobile-two-of="4"><Link to="#/information/">Information</Link></div>
						<div>{this.state.slide}/{entry.data.body1.length}</div>
					</div>
				</Container>
			</div>
			<SiteModifier hovermodifier={'teaser'} hover={true}>
			<div className="Template-teaser">
				<Link to={'/'} className="Template-teaser-link">Casswell Bank Architects</Link>
			</div>
			</SiteModifier>


			<div className={`Template-lightbox`}>
				<div className="Template-lightbox-close"><Link to={entry.uri}><Icon glyph type={'cross'} /></Link></div>
				<Data>
				{({SHOWIMAGE})=>{
					{
						return (SHOWIMAGE) ? <SiteModifier modifier="lightbox" key={'lightbox'} auto={true} /> : <SiteModifier demodifier="lightbox" key={'nolightbox'}  auto={true} />
					}
				}}
				</Data>
				<div className="Template-lightbox-frame">
					<Data>
					{({IMAGE})=>{
						if(IMAGE){
							return <Image src={IMAGE} lazy={true} fluid={true} />
						}else{
							return null;
						}
					}}
					</Data>
				</div>
			</div>

			</div>
		);

	}
}

export default Default;



// WEBPACK FOOTER //
// ./src/js/templates/default.js